export const GROUPS = [
    {
      title: "Top Awards",
      slugs: [
        "best_picture",
        "directing",
        "writing_original",
        "writing_adapted",
      ],
    },
    {
      title: "Acting",
      slugs: [
        "actor_leading",
        "actress_leading",
        "actor_supporting",
        "actress_supporting",
      ],
    },
    {
      title: "Technical & Craft",
      slugs: [
        "cinematography",
        "film_editing",
        "visual_effects",
        "music_original_score",
        "music_original_song",
        "sound",
        "production_design",
        "makeup_hairstyling",
        "costume_design",
        "casting",
      ],
    },
    {
      title: "Other Features & Shorts",
      slugs: [
        "international_feature_film",
        "animated_feature_film",
        "animated_short_film",
        "documentary_feature_film",
        "documentary_short_film",
        "live_action_short_film",
      ],
    },
  ];